import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import BreadCrumbs from "@components/breadcrumbs/index1";
import QuestionItem from "./QuestionItem";
import "./questionList.css";
import {
  getQuetionByQuizzId,
  answerFullVote
} from "../../../../redux/action/quizz/QuizzAction";
//import Wizard from "@src/@core/components/wizard/index.js";
import Wizard from "./Wizard";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import {handleErrorOne} from "@src/redux/action/GlobalAction.js"

const QuestionLisByid = (props) => {
  const vote_id = props.match.params.vote_id;
  //this state is user to determin if a question has a response or note

  var questionlist = useSelector(
    (store) => store.QuizzReducer.questionByQuizzId
  );
  const lastSelectedRadioIndex = useSelector(
    (store) => store.QuizzReducer.VoteRadioQuestionLastIndex
  );

  questionlist?.map((ele) =>
    ele?.quetionsOption?.sort((a, b) => {
      a.id - b.id;
    })
  );
  const dispatch = useDispatch();

  useEffect(() => {
    getQuetionByQuizzId(
      vote_id,
      ["id", "ques_text", "is_active", "createdAt", "updatedAt"],
      dispatch
    );

    return () => {
      getQuetionByQuizzId(
        vote_id,
        ["id", "ques_text", "is_active", "createdAt", "updatedAt"],
        dispatch
      );
    };
  }, []);

  const goToNext = (next) => {
    next();
  };

  const calculateSumVotes = (voteList) => {
    const sum = voteList.reduce((acc, ele) => acc + ele.counterVote, 0);
    return sum;
  };

  const handelOptionSelect = (e, i, j) => {
    if (e.target.type === "checkbox") {
      if (e.target.checked) {
        let newQuestionList = questionlist;
        newQuestionList[j].quetionsOption[i].counterVote += 1;
        newQuestionList[j].sumVote = calculateSumVotes(
          newQuestionList[j].quetionsOption
        );
        dispatch({
          type: "UPDATE_VOTE_QUESTION_FOR_STATS",
          data: newQuestionList
        });
      } else {
        let newQuestionList = questionlist;
        newQuestionList[j].quetionsOption[i].counterVote -= 1;
        newQuestionList[j].sumVote = calculateSumVotes(
          newQuestionList[j].quetionsOption
        );
        dispatch({
          type: "UPDATE_VOTE_QUESTION_FOR_STATS",
          data: newQuestionList
        });
      }
    } else {
      if (lastSelectedRadioIndex.length === 0) {
        dispatch({
          type: "UPDATE_VOTE_LAST_INDEX",
          data: questionlist.map((ele, index) => (index === j ? i : -1))
        });
        let newQuestionList = questionlist;
        newQuestionList[j].quetionsOption[i].counterVote += 1;
        newQuestionList[j].sumVote = calculateSumVotes(
          newQuestionList[j].quetionsOption
        );
        dispatch({
          type: "UPDATE_VOTE_QUESTION_FOR_STATS",
          data: newQuestionList
        });
      } else {
        if (lastSelectedRadioIndex[j] < 0) {
          let newQuestionList = questionlist;
          newQuestionList[j].quetionsOption[i].counterVote += 1;
          newQuestionList[j].sumVote = calculateSumVotes(
            newQuestionList[j].quetionsOption
          );
          dispatch({
            type: "UPDATE_VOTE_LAST_INDEX",
            data: lastSelectedRadioIndex.map((ele, index) =>
              index === j ? i : ele
            )
          });
          dispatch({
            type: "UPDATE_VOTE_QUESTION_FOR_STATS",
            data: newQuestionList
          });
        } else {
          let newQuestionList = questionlist;
          newQuestionList[j].quetionsOption[i].counterVote += 1;
          newQuestionList[j].quetionsOption[
            lastSelectedRadioIndex[j]
          ].counterVote -= 1;
          newQuestionList[j].sumVote = calculateSumVotes(
            newQuestionList[j].quetionsOption
          );
          dispatch({
            type: "UPDATE_VOTE_LAST_INDEX",
            data: lastSelectedRadioIndex.map((ele, index) =>
              index === j ? i : ele
            )
          });
          dispatch({
            type: "UPDATE_VOTE_QUESTION_FOR_STATS",
            data: newQuestionList
          });
        }
      }
    }
  };

  const handelSubmit = () => {
    const stepsInputs = document.getElementsByClassName("VoteFormelement");
    let inputsNames = [];
    let currentIndexInputs = [];
    let canGoNext = false;

    for (let i = 0; i < stepsInputs.length; i++) {
      inputsNames[i] = stepsInputs[i].id?.split("-")[2];
    }

    for (let i = 0; i < stepsInputs.length; i++) {
      if (inputsNames[i] == activeIndex) {
        currentIndexInputs.push(stepsInputs[i]);
      }
    }
    canGoNext = currentIndexInputs.map((ele) => ele.checked).some((ele) => ele);
    if (canGoNext) {
      let newQuizDto = questionlist.map((ele) => ({
        id: ele.id,
        sumVote: ele.sumVote,
        option: ele.quetionsOption.map((option) => ({
          id: option.id,
          counterVote: option.counterVote
        }))
      }));
      answerFullVote(dispatch, vote_id, { questions: newQuizDto }, () =>
        setActiveIndex(0)
      );
      const inputs = document.getElementsByClassName("VoteFormelement");
      for (let i = 0; i < inputs.length; i++) {
        inputs[i].checked = false;
      }
    } else {
      handleErrorOne("choose at leaste one choice");
    }
  };

  const handelCancelVote = () => {
    const inputs = document.getElementsByClassName("VoteFormelement");
    for (let i = 0; i < inputs.length; i++) {
      inputs[i].checked = false;
    }
    getQuetionByQuizzId(
      vote_id,
      ["id", "ques_text", "is_active", "createdAt", "updatedAt"],
      dispatch
    );
  };

  const { t } = useTranslation();
  // ** Ref
  const ref = useRef(null);
  // ** State
  const [stepper, setStepper] = useState(null);
  const [activeIndex, setActiveIndex] = useState(0);
  // template for header render
  const FrontofficeThemeReducer = useSelector(
    (state) => state.FrontofficeThemeReducer
  );
  const themeStore = FrontofficeThemeReducer;
  const tempalte = themeStore?.design_by_radio?.templates.id;

  var steps = [
    {
      id: "gogo",
      title: "question",
      subtitle: "question",
      content: <></>
    }
  ];
  steps = questionlist?.map((ele, i) => ({
    id: `question-item${i}-element`,
    title: ele.ques_text,
    subtitle: ele.multiChoice
      ? t("multi choice question")
      : t("mono choice question"),
    content: (
      <QuestionItem
        questionData={ele}
        j={i}
        sumVote={ele.sumVote}
        handelOptionSelect={handelOptionSelect}
        stepper={stepper}
        multiChoice={ele.multiChoice}
      />
    )
  }));

  return (
    <div
      className="QuestionsFrontOfficebody"
      style={{
        display: "flex",
        width: "100%",
        height: "100%",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center"
      }}
    >
      {tempalte === 2 ? (
        <BreadCrumbs
          breadCrumbTitle={
            t("Vote Name") + " : " + questionlist[0]?.QuesQuizz?.title
          }
        />
      ) : (
        <>
          <section className="single-banner" style={{ width: "100%" }}>
            <div className="container__">
              <div className="row">
                <div className="col-lg-12">
                  <div className="single-content">
                    <h2>
                      {t("Vote Name") +
                        " : " +
                        questionlist[0]?.QuesQuizz?.title}
                    </h2>
                    <ol className="breadcrumb">
                      <li className="breadcrumb-item">
                        <Link to="/">{t("Home")}</Link>
                      </li>
                    </ol>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </>
      )}

      <div className="QuestionsFrontOfficeContainer">
        {/* {questionlist?.map((ele,index)=>(ele.is_active ?<QuestionItem questionData={ele} key={"questionfrontoffice"+index} />:""))}  */}

        <div className="modern-vertical" style={{ marginTop: "40px" }}>
          <Wizard
            type="modern-vertical"
            ref={ref}
            steps={steps}
            instance={(el) => setStepper(el)}
            goToNext={goToNext}
            handelSubmit={handelSubmit}
            handelCancelVote={handelCancelVote}
            setActiveIndex={setActiveIndex}
            activeIndex={activeIndex}
          />
        </div>
      </div>
    </div>
  );
};

export default QuestionLisByid;
